<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="会议名称：">
            <el-input v-model="query.title" placeholder="请输入会议名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="会议类型：">
            <el-select v-model="query.categoryId" filterable clearable placeholder="请选择会议类型">
              <el-option v-for="item in meetingCategoryOptions" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="主讲老师：">
            <el-input v-model="query.lecturerKeyword" placeholder="请输入姓名/手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="timeFilter" placeholder="请选择" clearable size="small">
              <el-option label="发布报名时间" :value="1"></el-option>
              <el-option label="会议时间" :value="2"></el-option>
              <el-option label="修改会议时间" :value="3"></el-option>
              <el-option label="取消时间" :value="4"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card meet-content">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="未开始报名" name="10"></el-tab-pane>
          <el-tab-pane label="报名中" name="11"></el-tab-pane>
          <el-tab-pane label="会议待开始" name="20"></el-tab-pane>
          <el-tab-pane label="会议进行中" name="21"></el-tab-pane>
          <el-tab-pane label="已结束" name="22"></el-tab-pane>
          <el-tab-pane label="已取消" name="99"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <!-- <el-button type="primary" size="mini" @click="handleDownload" icon="el-icon-plus">导出</el-button> -->
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus"
            v-hasPermi="['meeting:meet:add']">添加会议</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <div class="table-container">
        <el-table ref="meetingTable" v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
          <!-- <el-table-column type="selection" width="50" /> -->
          <el-table-column label="会议号" prop="meetNo" align="center" width="180" />
          <el-table-column label="会议名称" prop="title" align="center" width="200" fixed>
            <template slot-scope="{ row }">
              <el-link type="primary" @click="handleShow(row, 2)">{{
                row.title
              }}</el-link>
            </template>
          </el-table-column>
          
          <el-table-column label="会议类型" prop="categoryName" align="center" width="140" />
          <el-table-column label="会议主图" prop="imageUrl" align="center">
            <template slot-scope="{ row }">
              <el-image style="width: 50px; height: 50px" :src="row.imageUrl"
                :preview-src-list="[row.imageUrl]"></el-image>
            </template>
          </el-table-column>
          <el-table-column label="主讲老师" prop="describe" align="center" width="140">
            <template slot-scope="{ row }">
              <template v-if="row.lecturerList && row.lecturerList.length > 0">
                {{ row.lecturerList[0].realName}}({{ row.lecturerList[0].levelName  }})
                {{ row.lecturerList[0].mobile }}<span v-if="row.lecturerList.length > 1">等</span><br />
              </template>
              <template v-else>
                {{ row.lecturerRealName }}({{ row.lecturerLevelName }})<br />{{
                  row.lecturerMobile
                }}
              </template>
            </template>
          </el-table-column>
          <el-table-column label="携带人数" prop="maxCarryPeople" align="center" />
          <el-table-column label="成人携带儿童人数" prop="maxCarryChildPer" align="center" />
          <el-table-column label="报名费用" prop="" align="center">
            <template slot-scope="{ row }">
              {{ row.feeList && row.feeList.length > 0?'指定身份参与':'所有人免费参与' }}
            </template>
          </el-table-column>
          <el-table-column label="签到距离(km)" prop="signUpRadius" align="center" width="140" />
          <el-table-column label="创建会议人" prop="userRealName" align="center" width="140">
            <template slot-scope="{ row }">
              {{ row.userRealName }}({{ row.userLevelName }})<br />{{
                row.userMobile
              }}
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="createdTime" sortable="custom" align="center" width="200" />
          <el-table-column label="报名时间" prop="signUpStartTime" sortable="custom" align="center" width="165">
            <template slot-scope="{ row }">
              {{ row.signUpStartTime }} ~ {{ row.signUpEndTime }}
            </template>
          </el-table-column>
          <el-table-column label="会议时间" prop="startTime" sortable="custom" align="center" width="165">
            <template slot-scope="{ row }">
              {{ row.startTime }} ~ {{ row.endTime }}
            </template>
          </el-table-column>
          <el-table-column label="是否开启签到" prop="isDeviceSignIn" align="center" width="140">
            <template slot-scope="{ row }">
              {{ row.isOpenDeviceSignIn ? "已开启" : "未开启" }}
            </template>
          </el-table-column>
          <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
          <el-table-column label="操作人" prop="operatedName" align="center" />
          <el-table-column label="操作" align="center" fixed="right" width="200">
            <template slot-scope="{ row }">
              <el-button type="text" @click="handleUpdate(row)" v-if="activeName === '10' || activeName === '11' || activeName === '20'"
                v-hasPermi="['meeting:meet:edit']">编辑</el-button>
              <el-button type="text" @click="handleCancel(row)" v-if="activeName === '10' || activeName === '11' || activeName === '20'"
                v-hasPermi="['meeting:meet:cancel']">取消会议</el-button>
              <el-button type="text" @click="handleQrcode(row)" v-if="
                activeName === '21' ||
                activeName === '11' ||
                activeName === '22'|| activeName === '20'
              " v-hasPermi="['meeting:meet:qrcode']">下载二维码</el-button>
              <el-button type="text" @click="handleLog(row)">日志记录</el-button>
              <!-- 已开启签到显示关闭签到，未开启显示开启签到 -->
              <el-button type="text" @click="handleCloseDeviceSignIn(row)" v-if="row.isOpenDeviceSignIn">关闭签到</el-button>
              <el-button type="text" @click="handleOpenDeviceSignIn(row)" v-else>开启签到</el-button>
              <el-button type="text" @click="handleSyncToDXIOT(row)">同步会议名称</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination v-show="total > 0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize"
        @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <meetingList-add ref="meetingListAdd" @created="doQueryList({})" :meetingCategoryOptions="meetingCategoryOptions" />
    <opera-vue ref="operaVue" @created="doQueryList({})" />
  </div>
</template>

<script>
import meetingListAdd from "./add";
import meetingApi from "@/api/meeting/meeting";
import Pagination from "@/components/Pagination";
import meetingCategoryApi from "@/api/meeting/meetingCategory";
import operaVue from "./opea.vue";
export default {
  components: {
    Pagination,
    operaVue,
    meetingListAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        status: 10, // 10 已发布 30 已取消
        statusSub: 10, //
        orderNoSortSign: 1
      },
      timeFilter: "",
      dateTime: [],
      selectItems: [],
      activeName: "10",
      meetingCategoryOptions: [],
      resizeTimer: null
    };
  },
  created() {
    // 从意向金管理「专题课」跳转过来时带会议名称，直接按它查
    if (this.$route.query.title) this.query.title = String(this.$route.query.title);
    this.doQueryList({ pageNo: 1 });
    meetingCategoryApi
      .fetchList({ pageNo: 1, pageSize: 100, isEnable: true })
      .then(({ data }) => {
        this.meetingCategoryOptions = data.list;
      });
  },
  mounted() {
    // 添加窗口大小变化监听，使用防抖处理
    this.$_handleResize = this.debounce(() => {
      this.$nextTick(() => {
        // 确保表格 DOM 已更新后，调用表格的 doLayout 方法
        const table = this.$refs.meetingTable;
        if (table && table.doLayout) {
          try {
            table.doLayout();
          } catch (error) {
            // 忽略 getBoundingClientRect 相关的错误
            if (!error.message || !error.message.includes('getBoundingClientRect')) {
              console.error('表格布局更新错误:', error);
            }
          }
        }
      });
    }, 200);
    
    window.addEventListener('resize', this.$_handleResize);
  },
  beforeDestroy() {
    // 清理 resize 事件监听器
    if (this.$_handleResize) {
      window.removeEventListener('resize', this.$_handleResize);
    }
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
  },
  methods: {
    handleFilter() {
      this.timeFilter = "";
      this.dateTime = [];
      this.query = {};
      this.doQueryList({ pageNo: 1, pageSize: 10 });
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val;
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        createdTime: "createdTimeSortSign",
        operatedTime: "operatedTimeSortSign"
      };
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k];
        if (k !== prop) {
          this.query[sortKey] = null;
        } else {
          if (order === "ascending") {
            this.query[sortKey] = 1;
          } else {
            this.query[sortKey] = -1;
          }
        }
      }
      this.doQueryList({});
    },
    handleClick() {
      this.doQueryList({ pageNo: 1 });
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 });
    },
    resetTime() {
      this.query.signUpStartTime = undefined;
      this.query.signUpEndTime = undefined;
      this.query.createdTimeStart = undefined;
      this.query.createdTimeEnd = undefined;
      this.query.createdTimeStart = undefined;
      this.query.createdTimeEnd = undefined;
      this.query.operatedTimeStart = undefined;
      this.query.operatedTimeEnd = undefined;
    },
    calcQuery() {
      this.query.statusSub =
        this.activeName === "99" ? undefined : +this.activeName;
      this.query.status = this.activeName === "99" ? 20 : 10;
      this.resetTime();
      if (this.dateTime && this.dateTime.length > 0) {
        if (this.timeFilter === 1) {
          this.query.signUpStartTime = this.dateTime[0];
          this.query.signUpEndTime = this.dateTime[1];
        } else if (this.timeFilter === 2) {
          this.query.startTime = this.dateTime[0];
          this.query.endTime = this.dateTime[1];
        } else if (this.timeFilter === 3) {
          this.query.createdTimeStart = this.dateTime[0];
          this.query.createdTimeEnd = this.dateTime[1];
        } else if (this.timeFilter === 4) {
          this.query.cancelTimeStart = this.dateTime[0];
          this.query.cancelTimeEnd = this.dateTime[1];
        }
      }
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo;
      }
      if (pageSize) {
        this.query.pageSize = pageSize;
      }
      this.calcQuery();
      this.listLoading = true;
      return meetingApi
        .fetchList(this.query)
        .then(data => {
          this.list = data.data.list;
          this.total = data.data.total;
        })
        .finally(() => {
          this.listLoading = false;
          // 数据更新后，在下一个 tick 更新表格布局
          this.$nextTick(() => {
            const table = this.$refs.meetingTable;
            if (table && table.doLayout) {
              try {
                table.doLayout();
              } catch (error) {
                // 忽略 getBoundingClientRect 相关的错误
                if (!error.message || !error.message.includes('getBoundingClientRect')) {
                  console.error('表格布局更新错误:', error);
                }
              }
            }
          });
        });
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common
        .confirm("是否确认删除")
        .then(() => meetingApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg("success", "删除成功");
          return this.doQueryList({ pageNo: 1 });
        });
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg("warning", "请选择角色");
        return;
      }
      return this.$common
        .confirm("是否确认删除")
        .then(() => meetingApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg("success", "删除成功");
          return this.doQueryList({ pageNo: 1 });
        });
    },
    handleCancel(row) {
      this.$refs.operaVue.handleCancel(row);
    },
    handleDownload() {
      return this.$common
        .confirm("是否确认导出")
        .then(() => meetingApi.exportExcel(this.query));
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.meetingListAdd.handleCreate(row);
    },
    /**
     * 打开查看表单
     */
    handleShow(row, type) {
      this.$emit("handleShow", row, type);
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.meetingListAdd.handleUpdate(row);
    },
    handleQrcode(row) {
      if (!row.qrCode) return;
      window.location.href = row.qrCode;
    },
    handleLog(row) {
      this.$router.push("/log/log?type=70&id=" + row.id);
    },
    /** 开启设备签到 */
    handleOpenDeviceSignIn(row) {
      if (!row.id) {
        this.$message.warning("会议信息异常");
        return;
      }
      this.$common
        .confirm("确认开启该会议的设备签到？")
        .then(() =>
          meetingApi
            .openDeviceSignIn(row.id)
            .then(() => {
              this.$message.success("开启成功");
              this.doQueryList({});
            })
            .catch()
        )
        .catch(() => {});
    },
    /** 关闭设备签到 */
    handleCloseDeviceSignIn(row) {
      if (!row.id) {
        this.$message.warning("会议信息异常");
        return;
      }
      this.$common
        .confirm("确认关闭该会议的设备签到？")
        .then(() =>
          meetingApi
            .closeDeviceSignIn(row.id)
            .then(() => {
              this.$message.success("关闭成功");
              this.doQueryList({});
            })
            .catch()
        )
        .catch(() => {});
    },
    /** 同步会议名称至DXIOT */
    handleSyncToDXIOT(row) {
      if (!row.id) {
        this.$message.warning("会议信息异常");
        return;
      }
      this.$common
        .confirm("确认同步该会议名称？")
        .then(() =>
          meetingApi
            .syncToDXIOT(row.id)
            .then(() => {
              this.$message.success("同步成功");
            })
            .catch()
        )
        .catch(() => {});
    },
    /**
     * 防抖函数
     */
    debounce(func, wait) {
      return (...args) => {
        if (this.resizeTimer) {
          clearTimeout(this.resizeTimer);
        }
        this.resizeTimer = setTimeout(() => {
          func.apply(this, args);
        }, wait);
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.app-container {
  display: flex;
  height: 100%;
  gap: 10px;
  flex-direction: column;

  .meet-content {
    flex: 1;

    ::v-deep .el-card__body {
      height: 100%;
      display: flex;
      flex-direction: column;

      .table-container {
        flex: 1;
        overflow-y: auto;
      }
    }
  }
}
</style>
